import { Component, ReactNode } from 'react'
import { GhostCta, Panel } from '../ui'

/**
 * A section that fails to draw must not take the page with it: the trade panel, the history and the chart are new and read the chain, so each sits in its own
 * boundary. The page around it keeps working; the section says so and offers a retry.
 */
export default class SectionBoundary extends Component<{ name: string; children: ReactNode }, { failed: boolean }> {
  constructor(props: { name: string; children: ReactNode }) {
    super(props)
    this.state = { failed: false }
  }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error: Error) {
    // the name and the error class only: nothing the user typed, no address
    // eslint-disable-next-line no-console
    console.error(`section ${this.props.name} failed:`, error?.name)
  }

  render() {
    const { failed } = this.state
    const { name, children } = this.props
    if (!failed) return children
    return (
      <Panel data-testid={`section-failed-${name}`} role="alert">
        <b>This section could not be shown.</b>
        <p style={{ margin: '4px 0 12px', fontSize: 14, opacity: 0.8 }}>The rest of the page works. Try again, or reload the page.</p>
        <GhostCta as="button" type="button" onClick={() => this.setState({ failed: false })} style={{ minHeight: 44 }}>Try again</GhostCta>
      </Panel>
    )
  }
}
